<div class="search-page">

  <h1>Поиск</h1>

  <div class="find-panel">
    <input #searchInput class="base-input" id="search" [hidden]="false"
           [(ngModel)]="search"
           [placeholder]="'Искать на полках'"
           (keyup.enter)="find(true)">
    <button mat-button class="main-button" (click)="find(true)">Поиск</button>

  </div>


  <mat-tab-group (selectedTabChange)="setBasePosition();setQueryParams()"
                 [(selectedIndex)]="selectedTab"
                 [@.disabled]="true"
                 [disableRipple]="true"

  >
    <mat-tab label="В наличии" class="prodact-list-search">
      <div class="find-result">
        <products #productsInStock class="products-list" *ngIf="selectedTab == 0"
                  [productsCountOnPage]="productsOnPage"
                  [availability]="'in_stock,expected'"
                  [search]="search"
                  [pageName]="'searchInStock'"
                  ></products>
      </div>
    </mat-tab>
    <mat-tab label="Под заказ" class="products-list-search">

      <div class="delivery-warning">{{deliveryWarningText}}</div>
      <div class="find-result">

      <products #productsToOrder class="products-list" *ngIf="selectedTab == 1"
                [productsCountOnPage]="productsOnPage"
                [availability]="'available_to_order'"
                [pageName]="'searchToOrder'"
                [search]="search"
      ></products>
      </div>

    </mat-tab>
  </mat-tab-group>

</div>
